import type { SupabaseClient } from '@supabase/supabase-js'
import { useQuery } from '@tanstack/react-query'

import { supabase } from '@/lib/supabase/cliente'
import { mensajeDeError } from '@/lib/supabase/errores'

/*
 * `conceptos_iva_libre` (0301) todavía no está en los tipos generados; se lee
 * sin tipos. La política deja leerla a cualquiera del personal.
 */
const sinTipos = supabase as unknown as SupabaseClient

/**
 * LOS ÚNICOS PRODUCTOS CON IVA MODIFICABLE (0301). Johan: mano de obra, grúa,
 * certificaciones, retroexcavadora, escalera y radicación ante el operador
 * de red. A lo demás se le deja el IVA de World Office (y la base también lo
 * impone al guardar).
 */
export function useConceptosIvaLibre() {
  return useQuery({
    queryKey: ['conceptos-iva-libre'],
    queryFn: async (): Promise<Set<number>> => {
      const { data, error } = await sinTipos.from('conceptos_iva_libre').select('id_inventario')
      if (error) throw new Error(mensajeDeError(error))
      return new Set(((data ?? []) as { id_inventario: number }[]).map((f) => Number(f.id_inventario)))
    },
    staleTime: 5 * 60_000,
  })
}
